import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { orderDetailsData } from '../../orders/reducer';

import HeaderLogoPF from '../HeaderLogoPF';
import OrderSummaryPF from './OrderSummaryPF';
import OrderShipmentsPF from './OrderShipmentsPF';
import OrderLineItemPF from './OrderLineItemPF';
import { CART_TYPES } from '../../carts/constants';

const BASE_CLASS = 'orderDetails__print';

export const OrderDetailsPF = ({ order, orderDetailsData, shipmentsView }) => {
  if (!order) return null;
  const { productDetails, currencyCode, paymentMethod } = order;
  const isForecast = order.orderType === CART_TYPES.FORECAST;

  return (
    <div className={BASE_CLASS}>
      <HeaderLogoPF />
      <OrderSummaryPF baseClass={BASE_CLASS} order={order} />
      {shipmentsView ? (
        <OrderShipmentsPF orderDetailsData={orderDetailsData} />
      ) : (
        productDetails &&
        Object.keys(productDetails).length > 0 && (
          <div className='pt4-sm'>
            {Object.keys(productDetails).map(productCode => (
              <>
                {productDetails[productCode] && (
                  <OrderLineItemPF
                    key={`${productCode}_${productDetails[productCode].colorName}`}
                    product={productDetails[productCode]}
                    currencyCode={currencyCode}
                    paymentMethod={paymentMethod}
                    baseClass={BASE_CLASS}
                    isForecast={isForecast}
                  />
                )}
              </>
            ))}
          </div>
        )
      )}
    </div>
  );
};

OrderDetailsPF.propTypes = {
  order: PropTypes.shape({
    productDetails: PropTypes.shape({
      colorName: PropTypes.string
    }),
    currencyCode: PropTypes.string,
    paymentMethod: PropTypes.string,
    orderType: PropTypes.string
  }),
  orderDetailsData: PropTypes.object,
  shipmentsView: PropTypes.bool
};

OrderDetailsPF.defaultProps = {
  order: null,
  orderDetailsData: null,
  shipmentsView: false
};

const mapStateToProps = state => ({
  order: orderDetailsData(state),
  orderDetailsData: orderDetailsData(state)
});

export default connect(mapStateToProps, {})(OrderDetailsPF);
